import { render, staticRenderFns } from "./4.payment.event-registration.vue?vue&type=template&id=22b72c82"
import script from "./4.payment.event-registration.vue?vue&type=script&lang=ts"
export * from "./4.payment.event-registration.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports